import React from 'react';
import {
  Redirect,
  useLocation,
  useRouteMatch,
  useParams,
} from 'react-router-dom';

const CustomerDetailsRedirect = () => {
  const location = useLocation();

  // The old link for overview page redirect. Remove after some days.
  const oldOverviewLinkMatch = useRouteMatch('/Customers/:adfitNo');

  const { adfitNo } = useParams();

  if (location.search && location.search.startsWith('?debitsuccessId=')) {
    let pathAdfitNo = location.search.replace('?debitsuccessId=', '');
    return <Redirect to={`/Customers/${pathAdfitNo}/Overview`} />;
  }

  if (oldOverviewLinkMatch && oldOverviewLinkMatch.isExact) {
    return <Redirect to={`/Customers/${adfitNo}/Overview`} />;
  }

  return <Redirect to={`/Customers`} />;
};

export default CustomerDetailsRedirect;
